import { gql } from '@urql/core';
import React from 'react';
import { useAppState } from '../../../client/providers/AppProvider';
import { HighSchoolInfoButtonsFragment } from '../../../generated/spin-graphql';
import { Tooltip } from '../../common/Tooltip';
import { EmailIcon } from '../../svg/EmailIcon';
import { PhoneIcon } from '../../svg/PhoneIcon';
import { DiscordIcon } from '../../svg/socials/DiscordIcon';

type Props = {
    highSchool: HighSchoolInfoButtonsFragment;
};

gql`
    fragment HighSchoolInfoButtons on espin_high_school {
        slug
        contact_email
        contact_name
        contact_phone
        socials {
            discord
        }
    }
`;

export const HighSchoolInfoButtons: React.FC<Props> = ({ highSchool }) => {
    const { subscribed, subtier } = useAppState();
    const canSeeContactInformation = !!subscribed && subtier > 1;

    return (
        <div className="info-button-container">
            {highSchool.socials?.discord && (
                <>
                    {canSeeContactInformation && (
                        <p className="info-button discord">
                            <DiscordIcon />
                            {highSchool.socials.discord}
                        </p>
                    )}
                    {!canSeeContactInformation && (
                        <Tooltip
                            buttonLink="/dashboard/subscriptions"
                            buttonLabel="Upgrade"
                            message="This feature is only available to Platinum and Diamond subscribers."
                            customButton={<DiscordIcon />}
                        />
                    )}
                </>
            )}
            {highSchool.contact_email && (
                <>
                    {canSeeContactInformation && (
                        <a href={`mailto:${highSchool.contact_email}`} className="info-button">
                            {highSchool.contact_email}
                        </a>
                    )}
                    {!canSeeContactInformation && (
                        <Tooltip
                            buttonLink="/dashboard/subscriptions"
                            buttonLabel="Upgrade"
                            message="This feature is only available to Platinum and Diamond subscribers."
                            customButton={<EmailIcon />}
                        />
                    )}
                </>
            )}
            {highSchool.contact_phone && (
                <>
                    {canSeeContactInformation && (
                        <a href={`tel:${highSchool.contact_phone}`} className="info-button">
                            <PhoneIcon />
                            {highSchool.contact_phone}
                        </a>
                    )}
                    {!canSeeContactInformation && (
                        <Tooltip
                            buttonLink="/dashboard/subscriptions"
                            buttonLabel="Upgrade"
                            message="This feature is only available to Platinum and Diamond subscribers."
                            customButton={<PhoneIcon />}
                        />
                    )}
                </>
            )}
        </div>
    );
};
